import { formatDate } from '@seen/core/dates'
import type { ExtendedObservation } from '@seen/core/models/observation'
import { Button, Separator } from '@seen/ui'
import type { JSX, ReactNode } from 'react'
import { ActivityList } from '#src/components/activity/ActivityList.tsx'
import { ScrollAreaContent } from '#src/components/core/scroll-area/ScrollAreaContent.tsx'
import { ScrollAreaHeader } from '#src/components/core/scroll-area/ScrollAreaHeader.tsx'
import { Sheet } from '#src/components/core/sheet/Sheet.tsx'
import { SheetContent } from '#src/components/core/sheet/SheetContent.tsx'
import { SheetTrigger } from '#src/components/core/sheet/SheetTrigger.tsx'
import { RichText } from '#src/components/RichText.tsx'
import { useObservationActivity } from '#src/components/UseObservationActivity.tsx'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface DayCenterDayNoteItemProps {
  dayCenterDayNote: ExtendedObservation
}

export function DayCenterDayNoteItem({
  dayCenterDayNote,
}: DayCenterDayNoteItemProps): JSX.Element {
  const title = (
    <>
      {dayCenterDayNote.effectiveDateTime && (
        <>
          {formatDate(dayCenterDayNote.effectiveDateTime)}&rsquo;s Day Center
          note re: ADL and IADL assistance
        </>
      )}
      {!dayCenterDayNote.effectiveDateTime &&
        'a Day Center note re: ADL and IADL assistance'}
    </>
  )
  return (
    <Sheet>
      <TimelineTextEntry
        actor={dayCenterDayNote.lastUpdatedBy}
        time={dayCenterDayNote.lastUpdated}
        action={
          <>
            updated{' '}
            <SheetTrigger asChild>
              <Button variant="link">{title}</Button>
            </SheetTrigger>
            <SheetContent>
              <ScrollAreaHeader>
                <h5>{title}</h5>
              </ScrollAreaHeader>
              <ScrollAreaContent className="text-sm">
                <RichText value={dayCenterDayNote.valueString ?? ''} />
                <div className="flex flex-col gap-4">
                  <Separator />
                  <h5>Activity</h5>
                  <DayCenterNoteActivity dayCenterDayNote={dayCenterDayNote} />
                </div>
              </ScrollAreaContent>
            </SheetContent>
          </>
        }
        reference={dayCenterDayNote.reference}
        originTask={dayCenterDayNote.queuedEditsOriginTask}
      />
    </Sheet>
  )
}

function DayCenterNoteActivity({
  dayCenterDayNote,
}: {
  dayCenterDayNote: ExtendedObservation
}): ReactNode {
  const activity = useObservationActivity(dayCenterDayNote)
  return <ActivityList>{activity}</ActivityList>
}
